
export const overlayInnerStyle = {
    backgroundColor: '#121A2C',
    padding: '8px',
    borderRadius: '4px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '160%',
    textAlign: 'center',
    color: '#FFFFFF',
    bottom: '7px'
};
